import { useQuery } from '@tanstack/react-query';

import { fetchEditor } from '../services/api/editors';

export const useEditor = (editorId?: string) => {
  return useQuery({
    queryKey: ['editor', editorId],
    queryFn: () => fetchEditor(editorId!),
    enabled: Boolean(editorId),
  });
};
